import { ApiDataAccess, Dictionary } from '@softline/core';
import { inject, Injectable } from '@angular/core';
import { StorageLocationProduct } from '../types/storage-articles';
import {
  SOFTLINE_API_STORAGE_LOCATION_PRODUCT,
  SOFTLINE_API_STORAGE_LOCATION_PRODUCTS,
  SOFTLINE_API_STORAGE_LOCATION_PRODUCTS_UPDATE_POSITION,
} from '../storage-location.api';
import { StorageLocationProductResponse } from '../types/storage-location-product-response';
import { PaginationQuery } from '../types/pagination.query';

@Injectable()
export class StorageLocationProductRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  getStorageLocationProducts(
    idStorage: number,
    queryParams?: PaginationQuery
  ): Promise<StorageLocationProductResponse> {
    return this.#dataAccess.get<StorageLocationProductResponse>({
      path: SOFTLINE_API_STORAGE_LOCATION_PRODUCTS,
      pathParams: { idStorage },
      queryParams: queryParams as unknown as Dictionary<unknown>,
    });
  }

  async move(
    idStorage: number,
    products: StorageLocationProduct[]
  ): Promise<StorageLocationProduct[]> {
    const response = await this.#dataAccess.create<
      StorageLocationProduct[],
      StorageLocationProduct[]
    >(
      {
        path: SOFTLINE_API_STORAGE_LOCATION_PRODUCTS_UPDATE_POSITION,
        pathParams: { idStorage },
      },
      products
    );
    return response;
  }

  async update(
    idStorage: number,
    idProduct: number,
    product: StorageLocationProduct
  ): Promise<StorageLocationProduct> {
    const response = await this.#dataAccess.update<
      StorageLocationProduct,
      StorageLocationProduct
    >(
      {
        path: SOFTLINE_API_STORAGE_LOCATION_PRODUCT,
        pathParams: { idStorage, idProduct },
      },
      product
    );
    return response;
  }

  async add(
    idStorage: number,
    body: { position: number; product: { id: number } }
  ): Promise<StorageLocationProduct[]> {
    return await this.#dataAccess.create(
      {
        path: SOFTLINE_API_STORAGE_LOCATION_PRODUCTS,
        pathParams: { idStorage },
      },
      body
    );
  }

  async deleteAll(idStorage: number): Promise<any> {
    return await this.#dataAccess.delete({
      path: SOFTLINE_API_STORAGE_LOCATION_PRODUCTS,
      pathParams: { idStorage },
    });
  }

  async delete(idStorage: number, idProduct: number): Promise<StorageLocationProduct> {
    return await this.#dataAccess.delete<StorageLocationProduct>({
      path: SOFTLINE_API_STORAGE_LOCATION_PRODUCT,
      pathParams: { idStorage, idProduct },
    });
  }
}
